<template>
    <a-card a-card title="Downloads" class="Custom--Card" :loading="loading">
      <template slot="extra">
        <a-select v-model="days" @change="getDownloads">
          <a-select-option value="7">Last 7 Days</a-select-option>
          <a-select-option value="30">Last 30 Days</a-select-option>
          <a-select-option value="60">Last 60 Days</a-select-option>
          <a-select-option value="90">Last 90 Days</a-select-option>
          <a-select-option value="120">Last 120 Days</a-select-option>
          <a-select-option value="150">Last 150 Days</a-select-option>
          <a-select-option value="180">Last 180 Days</a-select-option>
        </a-select>
        <a-divider type="vertical" />
        <a-button type="default" shape="circle" icon="sync" size="small" @click="getDownloads()"/>
      </template>
        <div v-if="downloads" >
          <BarChart :chartdata="downloads" :options="options" :styles="style"></BarChart>
        </div>
      </a-card>
</template>
<script>
import BarChart from '@/components/Graphs/BarChart.vue';
import Api from "@/services/Api";

export default {
  components: { BarChart },
  name: 'Downloads',
  data: function (){
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
          }]
        },
        title: {
            display: true,
            text: null
        },
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'top'
          }
        },
        showLine: false
      },
      loading: true,
      days: '7',
      refresh: false,
      style: {
        width: "100%",
        height: "300px"
      },
      downloads: {}
    }
  },
  methods: {
      getDownloads() {
          this.loading = true;
          Api.get(`/reports/downloads?days=${this.days}`).then(res => {
              let stats = res.data;
              let labels = [];
              let data = [];
              let total = 0;

              for (let key in stats) {
                  total += parseInt(stats[key]);
                  labels.push(key);
                  data.push(stats[key]);
              }

              this.downloads = {
                  labels: labels,
                  datasets: [
                      {
                          label: 'Downloads',
                          backgroundColor: '#0073AA',
                          data: data
                      }
                  ]
              }

              this.options.title.text = `${total} Downloads`;

              this.loading = false;
          }).catch(err => {
              this.$weNotify("error", "Failed to load data!");
              this.loading = false;
          })
      }
  },
  created() {
      this.getDownloads();
  }
}
</script>